import { DeviceEnum } from '~/enums/deviceEnum'

const getters = {
  menuKeys: state => state.menu.menuKeys,
  recentColors: state => state.theme.recentColors,
  isMobile: state => state.editor.device === DeviceEnum.MOBILE,
  isDesktop: state => state.editor.device === DeviceEnum.DESKTOP,
  visibleDialogIndex: state => state.site.visibleDialogIndex,
  isStandAloneMode: state => state.site.isStandAloneMode,
  shopCart(state) {
    return state.goods.shopCartList.reduce((total, item) => {
      total[item.goods_id] = item.goods_num
      return total
    }, {})
  },
  shopCartNumber(state) {
    return state.goods.shopCartList.reduce((total, item) => {
      total = total + item.goods_num
      return total
    }, 0)
  },
  rechargeValuePriceSettingMap(state) {
    return state.project.rechargeValueList.reduce((total, item) => {
      total[item.id] = item.prices_setting
      return total
    }, {})
  },
  newRechargeValuePriceSettingMap(state) {
    return state.project.newRechargeValueList.reduce((total, item) => {
      total[item.id] = item
      return total
    }, {})
  },
  rechargeValueIconMap(state) {
    return state.project.rechargeValueList.reduce((total, item) => {
      total[item.id] = item.icon
      return total
    }, {})
  },
  rechargeValueMap(state) {
    return state.project.rechargeValueList.reduce((total, item) => {
      total[item.id] = item
      return total
    }, {})
  },
  userId(state) {
    return state.user.siteUserInfo?.id
  },
  projectId(state) {
    return state.project.projectId
  }
}

export default getters
